import * as interactions from './interactions';
import * as typography from './typography';

export default { interactions, typography };
